import React from 'react'

function Meters() {
  return (
    <div>    <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_3253_55193)">
      <rect
        x="8"
        y="8.5"
        width="32"
        height="32"
        rx="16"
        fill="#CFD8DC"
      />
      <rect
        x="8"
        y="8.5"
        width="32"
        height="32"
        rx="16"
        fill="white"
      />
      <path
        d="M15.666 16.6667H19.8327V20.8334H15.666V16.6667ZM15.666 29.1667H19.8327V33.3334H15.666V29.1667ZM28.166 16.6667H32.3327V20.8334H28.166V16.6667ZM28.166 29.1667H32.3327V33.3334H28.166V29.1667ZM20.666 18.3334H27.3327V20.0001H20.666V18.3334ZM17.3327 21.6667H18.9993V28.3334H17.3327V21.6667ZM28.9993 21.6667H30.666V28.3334H28.9993V21.6667ZM20.666 30.0001H27.3327V31.6667H20.666V30.0001Z"
        fill="#666666"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_3253_55193"
        x="-9.53674e-07"
        y="0.499999"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3253_55193"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="-2" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3253_55193"
          result="effect2_dropShadow_3253_55193"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_3253_55193"
          result="shape"
        />
      </filter>
    </defs>
  </svg></div>
  )
}

export default Meters